import DomainResource from './DomainResource';
import merge from 'lodash/merge';
import Reference from './types/Reference';
import BN_AuthRegisterLedgerItem from '@/fhirworks/BN_AuthRegisterLedgerItem';

export default class BN_AuthRegister extends DomainResource {
    static __className = 'BN_AuthRegister';

    __objectStructure = {
        patient: Reference,
        auth: Reference,
        ledger: [BN_AuthRegisterLedgerItem],

        // first class extension
        exhausted: Boolean,
    };

    constructor(constructJson, className = 'BN_AuthRegister') {
        super(constructJson, className);
        this.createAndPopulateStructure(this.__objectStructure, constructJson);
        this.originalObjJson = this.toJSON();
    }

    toJSON() {
        return merge(super.toJSON(this), this.getJsonForStructure(this.__objectStructure));
    }
}
